import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `Entre 2015 y 2018, se observa una mejora paulatina en los puntajes en la prueba Simce de Lenguaje. Sin embargo, en 2022, primera medición post pandemia, el porcentaje de estudiantes que obtuvo un nivel adecuado disminuyó. En 2024, los resultados no solo revirtieron los retrocesos de la pandemia, sino que registraron los niveles más altos de toda la serie histórica iniciada en 2015, lo que se vio reflejado tanto en la expansión del grupo con nivel adecuado como en la contracción de aquel con nivel insuficiente. En 2025, la proporción de estudiantes con puntajes adecuados volvió a disminuir, pero solo un punto porcentual. La proporción con puntaje insuficiente aumentó en dos puntos.`,
    link: "https://public.flourish.studio/visualisation/20888330/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `Entre 2015 y 2024, el rendimiento en la prueba de Lenguaje mejoró tanto para niñas como para niños, reflejado en una mayor proporción de estudiantes con un nivel adecuado de aprendizajes. Sin embargo, en 2025 el indicador mejoró únicamente para las niñas, mientras que los niños la proporción de estudiantes con un nivel adecuado disminuyó en dos puntos.`,
    link: "https://public.flourish.studio/visualisation/20888371/embed",
  },
  {
    id: "graph3",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `Históricamente, los resultados en la prueba de Lenguaje han mostrado desigualdades significativas según la dependencia administrativa del establecimiento. En 2025, solo el 42% de las y los estudiantes de colegios públicos alcanzó un estándar adecuado de aprendizaje, cifra que asciende al 47% en colegios particulares subvencionados y al 68% en particulares pagados. En el extremo opuesto, el 32% del estudiantado en el sector público se ubicó en un nivel insuficiente de competencia, frente al 27% en el sector subvencionado y al 12% en el particular pagado. Cabe destacar que la educación pública mantuvo una tendencia al alza durante 2025, reflejada en el aumento de la proporción de estudiantes con un nivel adecuado. En contraste, los colegios particulares subvencionados no registraron mejoras en esta medición, mientras que los particulares pagados experimentaron una caída de un punto porcentual en el grupo de nivel adecuado.`,
    link: "https://public.flourish.studio/visualisation/20888412/embed",
  },
  {
    id: "graph4",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `En general, los estudiantes de zonas urbanas presentan mejores desempeños que los estudiantes de zona rural. En 2025, el porcentaje que alcanza  niveles adecuados es mayor en las zonas urbanas (48%) en comparación con las rurales (42%). Sin embargo, la diferencia se ha tendido a acortar: si en 2015 había 9 puntos de diferencia, 10 años después hay 6 puntos. Por otro lado, más estudiantes en zonas rurales alcanzan un nivel insuficiente (31%) en comparación con los de zonas urbanas (26%). Esta brecha alcanzó su punto máximo en 2022, pero ha disminuido en 2023.`,
    link: "https://public.flourish.studio/visualisation/20888393/embed",
  },
  {
    id: "graph5",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `En 2025, la región que obtuvo una mayor proporción de estudiantes que no alcanzaron las competencias mínimas en Lenguaje es Tarapacá con un 33% y luego Valparaíso y Atacama con un 30% cada una. Por el contrario, las regiones que tienen una mayor proporción de estudiantes con un nivel adecuado de conocimientos son Maule y Ñuble, ambas con un 50%. Respecto a la proporción de estudiantes con competencias elementales si bien hay variaciones por región, estas son mínimas.`,
    link: "https://public.flourish.studio/visualisation/23734586/embed",
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
            key={graph.id}
            onClick={() => handleMenuItemClick(graph.id)}
            style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
          >
            {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;


